const o = {
  focusRing: {
    innerBoxShadowSize: "1px",
    outerBoxShadowSize: "3px",
    insetBoxShadowSize: "2px"
  }
};
export {
  o as measure
};
